// src/pages/PeoplePage.jsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AddWorkerModal from "../components/AddWorkerModal";
import PeopleNavigation from "../components/PeopleNavigation";
import PersonalPeoplePage from "./PersonalPeoplePage";
import GuestsPeoplePage from "./GuestsPeoplePage";
import PermanentInvitationsPeoplePage from "./PermanentInvitationsPeoplePage";

function PeoplePage() {
  const location = useLocation();
  const [showAddWorkerModal, setShowAddWorkerModal] = useState(false);
  // По умолчанию активная вкладка 'guests'
  const [activeTab, setActiveTab] = useState("guests");

  // Функция для определения, мобильное ли устройство
  const isMobile = () => {
    return window.innerWidth <= 768;
  };

  useEffect(() => {
    if (location.state && location.state.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container mx-auto max-w-5xl px-4 py-12 mt-2" style={{ fontSize: isMobile() ? '0.9rem' : '1rem' }}>
        <div className="bg-white rounded-lg shadow-md p-6 mb-1">
          <h1 className="text-2xl font-bold mb-4 text-gray-800">
            Here you can configure your staff, permanent lists, and invitations
          </h1>

          <div className="mb-6">
            <PeopleNavigation activeTab={activeTab} onTabChange={handleTabChange} className="mr-4" />
          </div>
        </div>

        {activeTab === "guests" && <GuestsPeoplePage />}
        {activeTab === "invitations" && <PermanentInvitationsPeoplePage />}
        {activeTab === "personal" && <PersonalPeoplePage />}

        <AddWorkerModal
          isOpen={showAddWorkerModal}
          onClose={() => setShowAddWorkerModal(false)}
          token={localStorage.getItem("token") || ""}
          onCreated={(invData) => {
            console.log("WorkerInvitation created:", invData);
          }}
        />
      </div>
    </div>
  );
}

export default PeoplePage;